module.exports = __webpack_public_path__ + "img/lingyuankaidian-sp.78c36317.png";